import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'clientName'
})
export class ClientNamePipe implements PipeTransform {

  transform(value: string): string {
    return value.replace('MARVEL_', '');
  }

} 